import PropTypes from 'prop-types'

export const fieldContainerProps = {
  /** Must be the same id used in the input component */
  id: PropTypes.string.isRequired,
  /** A validation error message to be shown to the user */
  error: PropTypes.string,
  /** A validation warning message to be shown to the user */
  warning: PropTypes.string,
  /** True if the user focused and blurred the field, otherwise false. Used to prevent showing validation errors before the user has entered any data */
  touched: PropTypes.bool
}

export const fieldProps = {
  /** The field name */
  name: PropTypes.string.isRequired,
  /** Indicates the cursor is currently on the field */
  focus: PropTypes.bool,
  /** Ref that will be passed to the input component */
  inputRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  /** Props that will be passed to the input component */
  inputProps: PropTypes.object,
  /** Disables the field for input */
  disabled: PropTypes.bool,
  /** Brings the cursor to the field automatically after it renders */
  autoFocus: PropTypes.bool,
  /** Time in milliseconds to wait before moving the cursor to the field after it renders */
  autoFocusDelay: PropTypes.number,
}

export const fixedLengthInputProps = {
  /** Text that will be shown inside the input before the user enters any data */
  placeholder: PropTypes.string,
  /** The label displayed to the user after the field has any value */
  label: PropTypes.string,
  /** The initial value to be displayed in the input */
  initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Disables or enables browser autocomplete for the field */
  autoComplete: PropTypes.bool,
  /** Adds a class to instruct inspectlet and other libraries that the field should not have it's value disclosed on analytics */
  sensitive: PropTypes.bool,
  /** True if hide the check icon for filled field */
  hideCheckIcon: PropTypes.bool,
  /** default: regular appearance used in prequal forms; compact: smaller inputs to fit smaller forms and widgets */
  appearance: PropTypes.oneOf(['default', 'compact'])
}

export const inputProps = {
  ...fixedLengthInputProps,
  /** Maximum number of characters in the input (does not consider the thousand separators, decimals or prefix for number-based inputs) */
  maxLength: PropTypes.number,
}

export const badgeProps = {
  /** Adds a badge on the left part of the field with either a cred-icon if a string is provided, or any other content if a react node is provided */
  leftBadge: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Adds a badge on the right part of the field with either a cred-icon if a string is provided, or any other content if a react node is provided */
  rightBadge: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export const analyticsProps = {
  /** Configures analytics for the field */
  analytics: PropTypes.shape({
    /** Wether to disable analytics events to be captured and registered or not */
    disabled: PropTypes.bool,
    /** The events that should be captured by analytics */
    events: PropTypes.arrayOf(PropTypes.oneOf(['onChange', 'onBlur'])),
    /** Function to format the value before sendding the event */
    format: PropTypes.func,
    /** Data to override the values that are sent by the field to the analytics event */
    data: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      label: PropTypes.string,
      errorMessage: PropTypes.string,
    })
  })
}